import React, { useEffect, useMemo, useState } from "react";
import PlanningsHeading from "./planning-Heading/PlanningHeading";
import PlanningsDetails from "./planning-Details/PlanningsDetails";
import { useAppSelector } from "src/redux/store";
import { IPlanDetail } from "src/types/planning";
import { BookedSchedule } from "src/types/schedule";

const Plannings: React.FC = () => {
  const currentPlan = useAppSelector<IPlanDetail>(
    (state) => state.planSlice.currentPlan
  );
  const Bookeddata = useAppSelector<BookedSchedule[]>(
    (state) => state.scheduleListSlice.bookedListData
  );
  //tracks selection changes in planning calender list
  const [changedList, setchangedList] = useState<boolean>(false);

  // Get all pending schedules for the current plan
  const allPendingSchedules = useMemo(() => {
    const clientPendingSchedules = Bookeddata.filter(
      (item) =>
        item.bookedClientId?.id &&
        item.status === "Pending" &&
        currentPlan.plan.clients.includes(item.bookedClientId?.id)
    );

    const providerPendingSchedules = Bookeddata.filter(
      (item) =>
        item.bookedProviderId &&
        item.status === "Pending" &&
        currentPlan.plan.providers.includes(item.bookedProviderId.id)
    );

    return [...clientPendingSchedules, ...providerPendingSchedules];
  }, [Bookeddata, currentPlan.plan.clients, currentPlan.plan.providers]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("schedule");
    };
  }, []);

  return (
    <div className="pageTemplate mapDetailsTemplate">
      <PlanningsHeading
        changedList={changedList}
        setchangedList={setchangedList}
        allPendingSchedules={allPendingSchedules}
        currentPlan={currentPlan}
      />
      <PlanningsDetails
        setchangedList={setchangedList}
        pendingSchedulesCount={allPendingSchedules.length}
      />
    </div>
  );
};

export default Plannings;
